export class Loader {
    public isLoading = false
    public go() {
        this.isLoading = true
    }
    public stop() {
        this.isLoading = false
    }
}

const global = {
    install(Vue: any) {
        Vue.prototype.$loader = Vue.observable(new Loader())
    }
}

export default global
